import React from 'react';
import './profileManagementViewHeader.scss';

import { PageHeader } from 'pepsico-ds';

export const ProfileManagementViewHeader = () => {
  return (
    <div className='admin-profile_profile-management-view-header flex flex-col items-start justify-start'>
      <div className='flex flex-row items-center justify-start'>
        <PageHeader title='Profile Management' />
      </div>
    </div>
  );
};
